/**
 *
 */
export const DISCOUNT_TYPES = {
  PROMOTION: 0, // Promoções cadastradas na Retaguarda
  TOTAL_DISCOUNT_ON_SALES: 1, // Desconto total da venda (Manual)
  RESHOP: 3, // Desconto do Reshop
  FOUR_ALL: 4, // Desconto da FOUR_ALL
};
